let swiperPromise = null

export const loadSwiper = () => {
  if (!swiperPromise) {
    swiperPromise = Promise.all([import('swiper'), import('swiper/css/bundle')])
      .then(([swiperModule]) => {
        const { default: Swiper, Navigation, Pagination, Grid } = swiperModule
        return { Swiper, Navigation, Pagination, Grid }
      })
      .catch(error => {
        swiperPromise = null
        throw error
      })
  }

  return swiperPromise
}
